// ============================================================
//  YICEL — Site configuration
//  Edit links, images and texts here. All placeholders in one place.
// ============================================================

export const siteConfig = {
  artist: {
    name: "Yicel",
    tagline: "Canciones honestas para los que sienten de verdad.",
    heroMessage:
      "Esta soy yo. Sin filtros, sin máscaras. Lo que escucho en mi cabeza a las 3 AM, hecho canción.",
  },

  // ------------------------------------------------------------
  // IMAGES — swap any URL here to change images site-wide
  // ------------------------------------------------------------
  images: {
    logo:
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/v3sb6ge2_FullLogo_Transparent%20%281%29.png",
    heroPortrait:
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/rgm2xvn6_MORADO.jpg",
    epCover:
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/op4a9gat_WhatsApp%20Image%202026-03-16%20at%2022.33.12.jpeg",
    singleCover:
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/kh3hq66n_Dando%20vueltas%20por%20Madrid%20upscaled.png",
    aboutPortrait:
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/1zy5z454_DSC06538.jpg",
    gallery: [
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/i5uuo4oh_DSC06863-3.jpg",
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/8ii40jfb_20240617_165120.jpg",
      "https://customer-assets.emergentagent.com/job_yicel-honesta/artifacts/axe0mttn_20250906_173641.jpg",
    ],
  },

  // ------------------------------------------------------------
  // EP & SINGLES — replace with your real links
  // ------------------------------------------------------------
  ep: {
    title: "El Amor No Alcanza",
    year: "2026",
    description:
      "Un EP sobre soltar lo que duele y entender que simplemente El Amor no Alcanza. 5 canciones, una verdad.",
    // Hasta que el EP esté publicado, los botones abren el perfil del artista
    // y el smart link del sencillo. Reemplaza con el URL del EP cuando salga.
    spotify: "https://open.spotify.com/artist/0iuxH5PwYu3OBxVb0dgMV6",
    appleMusic: "https://ffm.to/dando-vueltas-por-madrid/apple",
    youtube: "https://www.youtube.com/@yicelmusic",
  },

  featuredSingle: {
    title: "Dando vueltas por Madrid",
    overline: "Nuevo sencillo",
    description: "",
    // Spotify artist embed (oficial desde Spotify)
    spotifyEmbed:
      "https://open.spotify.com/embed/artist/0iuxH5PwYu3OBxVb0dgMV6?utm_source=generator",
    spotifyLink: "https://open.spotify.com/track/6zJea7g4NlpP4sg1xw75Yf",
    appleMusicLink: "https://ffm.to/dando-vueltas-por-madrid/apple",
  },

  otherSongs: [
    {
      title: "Medicina",
      youtubeEmbed: "https://www.youtube.com/embed/8Sg-rH-zpbk",
      description: "A veces el amor no cura — también enferma.",
    },
  ],

  // ------------------------------------------------------------
  // LISTENING PARTY
  // ------------------------------------------------------------
  listeningParty: {
    title: "Listening Party",
    subtitle: "Lanzamiento EP",
    venue: "Caleidoscopio",
    city: "Cali, Colombia",
    // ISO datetime — 4 May 2026, 8:00 PM Cali (UTC-5)
    date: "2026-05-04T20:00:00-05:00",
    dateLabel: "4 de mayo · 2026",
    timeLabel: "8:00 PM",
    capacityNote: "Cupos limitados",
    ticketLink: null, // null = muestra "próximamente"
  },

  // ------------------------------------------------------------
  // SOCIAL
  // ------------------------------------------------------------
  social: {
    instagram: "https://www.instagram.com/yicel_music/",
    tiktok: "https://www.tiktok.com/@yicel.music",
    youtube: "https://www.youtube.com/@yicelmusic",
    linkInBio: "https://ffm.bio/yicel",
    spotify: "https://open.spotify.com/artist/0iuxH5PwYu3OBxVb0dgMV6",
    appleMusic: "#",
  },

  // ------------------------------------------------------------
  // ABOUT
  // ------------------------------------------------------------
  about: {
    bio: `Soy Yicel. Escribo canciones sobre lo que no sé decir en voz alta.
Nací en Colombia y crecí escuchando baladas que mi mamá ponía los domingos.
Mi música es eso: una conversación íntima, sin filtros, con quien quiera escuchar.`,
    quote: "No hago música para impresionar. La hago para acompañar.",
  },

  newsletter: {
    title: "Únete y sé parte de este viaje",
    description:
      "Sin spam. Solo avisos cuando salga música nueva, fechas de shows y pensamientos que no caben en redes.",
  },
};

export default siteConfig;
